import React from 'react';
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Layout from '../components/layout';
import SEO from '../components/seo';
import settings from '../../settings';

const topbanner = `${settings.IMAGES_BASE_URL}/images/contactus/contact-bmw-pdc.jpg`;

const ContactUs = () => (
  <Layout>
    <SEO title="BMW Performance Driving School | 404" />
    <div className='contact-us'>
      <LazyLoadImage effect="blur" src={topbanner} alt="BMW 404 Page" />
      <div className="container">
        <div>
          <h3>CONTACT INFORMATION FOR THE BMW PERFORMANCE CENTER</h3>
          <p>
            The BMW Performance Center has locations at:
          </p>
            <h4>BMW Performance Center</h4>
            <p>1155 SC-101, Greer, SC 29651</p><br/><br/>
            <h4>BMW Performance Center West</h4>
            <p>86-050 Jasper Lane, Thermal, CA 92274<br/><br/>
              Contact us at:<br/> <a href="mailto:support@bmwpcds.com">support@bmwpcds.com</a><br/> (888) 345-4269
            </p>
          </div>
      </div>
    </div>
  </Layout>
);

export default ContactUs;